// extracted by mini-css-extract-plugin
module.exports = {"sortMenu":"SortMenu_sortMenu__czNc8","sortLabelsContainer":"SortMenu_sortLabelsContainer__3QK9I","sortLabel":"SortMenu_sortLabel__2NO9V"};